// extracted by mini-css-extract-plugin
export default {"Custom_Box":"Box_Custom_Box__7RbFz"};